import { createFileRoute } from '@tanstack/react-router';
import { CompanyCardsPage } from '@/features/purchasing/CompanyCards';
import { cardStatusLabels, type CardStatus } from '@/features/purchasing/cards-api';

export const Route = createFileRoute('/_dashboard/dashboard/purchasing/cards')({
  validateSearch: (search: Record<string, unknown>): { cardStatus?: CardStatus | 'ALL' } => ({
    cardStatus:
      search.cardStatus === 'ALL' ||
      (typeof search.cardStatus === 'string' && search.cardStatus in cardStatusLabels)
        ? (search.cardStatus as CardStatus | 'ALL')
        : undefined,
  }),
  component: Page,
});

function Page() {
  const { cardStatus } = Route.useSearch();
  return <CompanyCardsPage initialStatus={cardStatus} />;
}
